"use client";

import { Modal } from "react-bootstrap";
import classes from "./modalSkeleton.module.css";
import { AiOutlineClose } from "react-icons/ai";
import useEscKey from "customHooks/useEscKey";

export default function ModalSkeleton({
  show,
  setShow,
  header,
  footer,
  children,
  modalClass,
  hideHeaderBorder,
  headerStyles,
  footerStyles,
  showCloseIcon,
  width,
  borderLine = true,
  headerClass,
  hideModalBg = false,
  enableEscKey = true,
  type = "center",
  onLeft = false,
  backdrop = false,
}) {
  function handleClose() {
    setShow(false);
  }

  // Use ESC key hook to close modal when ESC is pressed
  useEscKey(handleClose, show && enableEscKey);
  return (
    <>
      <style>{`
        .modal-dialog-centered {
          height: 100% !important;
        }
           ${
             type === "filter" &&
             `.modal .modal-dialog.modal-dialog-centered {
          height: 100% !important;
          margin: 0;
          ${
            onLeft
              ? "margin-right: auto !important;"
              : "margin-left: auto !important;"
          }
          ${onLeft ? "margin-left:140px;" : ""}
        }`
           }
        .modal-header {
          border-bottom: ${
            hideHeaderBorder ? "none" : `1px solid var(--main-color-yellow)`
          };
        }
        .modal-footer {
          margin: 0px;
          display: unset;
          justify-content: unset;
          align-items: unset;
          padding: ${!borderLine ? "15px 30px" : "0px"};
        }

        .${classes.header} button {
          color: var(--black-color) !important;
        }
        .modal-content {
          margin: ${true ? `0 auto 0 auto` : `0 0 0 auto`};
          background-color: ${hideModalBg ? "transparent" : ""};
          border: ${hideModalBg ? "none" : ""};
          ${type === "filter" && "height: 100% !important;"}
          ${type === "filter" && "border-radius: 0px !important;"}
        }
        .modal-body{
          max-height: 80vh !important;
          ${type === "filter" && "max-height: 100% !important;"}

        }
        .modal .modal-dialog {
          max-width: ${width};
          margin: ${true ? `0 auto 0 auto` : `0 0 0 auto`};
        }
        @media screen and (max-width: 992px) {
          .modal .modal-dialog {
            max-width: 70%;
          }
        }
        @media screen and (max-width: 768px) {
          .modal .modal-dialog {
            max-width: 80%;
          }
        }
        @media screen and (max-width: 575px) {
          .modal .modal-dialog {
            max-width: 90%;
          }
        }
      `}</style>

      <Modal
        show={show}
        onHide={handleClose}
        centered
        className={`  ${[classes.modal].join(" ")} `}
        {...(backdrop ? { backdrop: "static" } : {})}
      >
        {header && (
          <Modal.Header
            // closeButton
            className={`${[classes.header, headerClass && headerClass].join(
              " ",
            )}`}
            style={{ ...headerStyles }}
          >
            <h4>{header}</h4>
          </Modal.Header>
        )}
        {showCloseIcon && (
          <div className={classes.iconBox} onClick={handleClose}>
            <AiOutlineClose size={20} />
          </div>
        )}
        <Modal.Body
          className={`${[classes.body, modalClass && modalClass].join(" ")}`}
        >
          {children}
        </Modal.Body>
        {footer && (
          <Modal.Footer
            className={`${[classes.footer].join(" ")}`}
            style={{
              //   borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              ...footerStyles,
            }}
          >
            <div>{footer}</div>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
}
